module.exports = __webpack_public_path__ + "img/Frame 28.d8bbea27.png";